export default __webpack_public_path__ + "static/media/Group 4.8b9604d0.png";